import { render, staticRenderFns } from "./TopSizeChart.vue?vue&type=template&id=3a6b5fe2&"
import script from "./TopSizeChart.vue?vue&type=script&lang=js&"
export * from "./TopSizeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports